import { createFileRoute } from "@tanstack/react-router";
import { LanguageDetailPage } from "../../../components/system/LanguageDetailPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/localization/$languageId/")({
  beforeLoad: requireSuperAdmin(),
  component: LanguageDetailRoute,
});

function LanguageDetailRoute() {
  const { languageId } = Route.useParams();
  return <LanguageDetailPage languageId={languageId} />;
}
